import { render, staticRenderFns } from "./TestimonialsComponent.vue?vue&type=template&id=1c2a5c73&scoped=true"
import script from "./TestimonialsComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialsComponent.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsComponent.vue?vue&type=style&index=0&id=1c2a5c73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a5c73",
  null
  
)

export default component.exports